export default {"src":"/_next/static/media/SONIC.ac373823.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};